/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ModuleManifest } from "shared/bootstrap";
import store from "modules/invoices/store";
import { VuePlugins } from "shared/bootstrap/types";
import publicLocale from "./i18n/public.json";
import adminLocale from "./i18n/admin.json";

const manifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "my-invoices" },
      title: "invoices.menuItems.myInvoices",
      icon: "file-invoice",
      hideNoAuth: true
    }
  ],
  routes: [
    {
      path: "/mijn-facturen",
      name: "my-invoices",
      meta: {
        auth: true,
        title: "invoices.menuItems.myInvoices"
      },
      component: () => import("./pages/MyInvoices.vue")
    }
  ],
  storeModules: {
    invoices: store
  },
  widgets: [
    {
      name: "InvoiceInfo",
      component: () => import("./widgets/InvoiceInfo.vue")
    }
  ],
  localisation: { key: "invoices", messages: publicLocale }
};

export default manifest;

export const AdminManifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "invoice-access-logs" },
      title: "invoices.menuItems.invoiceAccessLogs",
      icon: "file-invoice"
    }
  ],
  routes: [
    {
      path: "/factuur-downloads",
      name: "invoice-access-logs",
      component: () => import("./pages/AccessLogs.vue"),
      meta: {
        title: "invoices.menuItems.invoiceAccessLogs"
      }
    }
  ],
  storeModules: {
    invoices: store
  },
  vuePlugins: [VuePlugins.CompendaIntegration],
  localisation: { key: "invoices", messages: adminLocale }
};
